// ═══════════════════════════════════════
// ADMIN LIGHT THEME — Shared Design Tokens
// Import this in every admin page
// ═══════════════════════════════════════

export const A = {
  // Backgrounds
  bg:        '#f8f5f1',   // Page background - warm white
  surface1:  '#ffffff',   // Sidebar, cards
  surface2:  '#fdf9f6',   // Secondary cards
  surface3:  '#f3ede6',   // Input fields, hover states
  surface4:  '#ece4db',   // Borders, dividers

  // Brand
  accent:       '#c96428',
  accentHover:  '#a84e1e',
  accentSoft:   'rgba(201,100,40,0.08)',
  accentMedium: 'rgba(201,100,40,0.15)',
  accentBorder: 'rgba(201,100,40,0.25)',

  // Text
  text1:  '#1a0f00',   // Primary — dark brown
  text2:  '#4a2c0a',   // Secondary
  text3:  '#8b6347',   // Muted
  text4:  '#b8956a',   // Faint

  // Borders
  border1: '#e8ddd3',
  border2: '#f0e8df',

  // Shadows
  shadow:   '0 1px 4px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)',
  shadowMd: '0 4px 24px rgba(0,0,0,0.10)',
  shadowLg: '0 8px 40px rgba(0,0,0,0.14)',

  // Status
  green:  '#16a34a', greenBg:  'rgba(22,163,74,0.08)',  greenBorder:  'rgba(22,163,74,0.2)',
  blue:   '#2563eb', blueBg:   'rgba(37,99,235,0.08)',  blueBorder:   'rgba(37,99,235,0.2)',
  yellow: '#d97706', yellowBg: 'rgba(217,119,6,0.08)',  yellowBorder: 'rgba(217,119,6,0.2)',
  orange: '#ea580c', orangeBg: 'rgba(234,88,12,0.08)',  orangeBorder: 'rgba(234,88,12,0.2)',
  purple: '#7c3aed', purpleBg: 'rgba(124,58,237,0.08)', purpleBorder: 'rgba(124,58,237,0.2)',
  red:    '#dc2626', redBg:    'rgba(220,38,38,0.08)',  redBorder:    'rgba(220,38,38,0.2)',
};

export const STATUS_COLORS = {
  pending:   { bg: A.yellowBg,  color: A.yellow, border: A.yellowBorder },
  confirmed: { bg: A.blueBg,    color: A.blue,   border: A.blueBorder   },
  preparing: { bg: A.orangeBg,  color: A.orange, border: A.orangeBorder },
  ready:     { bg: A.purpleBg,  color: A.purple, border: A.purpleBorder },
  delivered: { bg: A.greenBg,   color: A.green,  border: A.greenBorder  },
  cancelled: { bg: A.redBg,     color: A.red,    border: A.redBorder    },
  rejected:  { bg: A.redBg,     color: A.red,    border: A.redBorder    },
  admin:     { bg: A.purpleBg,  color: A.purple, border: A.purpleBorder },
  staff:     { bg: A.accentSoft, color: A.accent, border: A.accentBorder },
};

export const card = (extra = {}) => ({
  background: A.surface1,
  border: `1px solid ${A.border1}`,
  borderRadius: 16,
  boxShadow: A.shadow,
  ...extra,
});

export const input = {
  width: '100%',
  padding: '11px 14px',
  borderRadius: 10,
  border: `1px solid ${A.border1}`,
  background: A.surface3,
  color: A.text1,
  fontSize: 14,
  fontFamily: 'inherit',
  outline: 'none',
  transition: 'border-color 0.15s, box-shadow 0.15s',
};

export const btnPrimary = {
  background: `linear-gradient(135deg, ${A.accent}, ${A.accentHover})`,
  color: 'white',
  border: 'none',
  borderRadius: 10,
  padding: '10px 20px',
  fontSize: 14,
  fontWeight: 600,
  fontFamily: 'inherit',
  cursor: 'pointer',
  boxShadow: '0 2px 8px rgba(201,100,40,0.25)',
  transition: 'all 0.15s',
};

export const btnSecondary = {
  background: A.surface3,
  color: A.text2,
  border: `1px solid ${A.border1}`,
  borderRadius: 10,
  padding: '10px 20px',
  fontSize: 14,
  fontWeight: 500,
  fontFamily: 'inherit',
  cursor: 'pointer',
  transition: 'all 0.15s',
};

export const btnDanger = {
  background: A.redBg,
  color: A.red,
  border: `1px solid ${A.redBorder}`,
  borderRadius: 8,
  padding: '7px 14px',
  fontSize: 12,
  fontWeight: 600,
  fontFamily: 'inherit',
  cursor: 'pointer',
  transition: 'all 0.15s',
};

export const StatusBadge = ({ status }) => {
  const s = STATUS_COLORS[status] || STATUS_COLORS.pending;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: '3px 10px', borderRadius: 99,
      fontSize: 11, fontWeight: 600, textTransform: 'capitalize', letterSpacing: 0.3,
      background: s.bg, color: s.color, border: `1px solid ${s.border}`,
    }}>{status}</span>
  );
};
